




















































import { Vue, Component, Provide, Watch } from "vue-property-decorator";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

@Component
export default class App extends Vue {
  @Provide()
  getTitle() {
    return process.env.VUE_APP_APP_TITLE;
  }

  showSyncWin = false;
  showImportLogWin = false;
  viewLogType = -1;

  created() {
    this.restoreTask();
  }

  restoreTask() {
    if (!this.$store.getters["synctask/isProgress"]) {
      return;
    }
    const synctask = this.$store.state.synctask;
    if (synctask.importTask.status === "RUNNING") {
      this.$store.dispatch("synctask/progressImport", { taskId: synctask.importTask.taskId, projectId: synctask.importTask.projectId });
    }
    if (synctask.patentTextTask.status === "RUNNING") {
      this.$store.dispatch("synctask/progressPatentText", { taskId: synctask.patentTextTask.taskId, projectId: synctask.patentTextTask.projectId });
    }
  }

  getTaskImportStatus(status: Nullable<string>) {
    let message = "";
    switch (status) {
      case "RUNNING":
        message = "导入运行中";
        break;
      case "COMPLETED":
        message = "导入完成";
        break;
      case "NOT_STARTED":
      default:
        message = "未开始";
        break;
    }
    return message;
  }

  get importData() {
    return this.$store.state.synctask.importTask;
  }

  get patentTextData() {
    return this.$store.state.synctask.patentTextTask;
  }

  get taskList() {
    const syncTask = this.$store.state.synctask;
    return [
      { index: 0, name: "Excel项目数据导入", status: syncTask.importTask.status, percentage: this.getImportPercentage() },
      { index: 1, name: "代码化全文/法律状态", status: syncTask.patentTextTask.status, percentage: this.getPatentTextPercentage() }
    ];
  }

  getImportPercentage() {
    const message = this.$store.state.synctask.importTask;
    if (message.status === "COMPLETED") {
      return 100;
    }
    if (message.status === "NOT_STARTED") {
      return 0;
    }
    return parseInt((((message.finished + message.skipped) / (message.count || 1)) * 100).toString());
  }

  getPatentTextPercentage() {
    const message = this.$store.state.synctask.patentTextTask;
    if (message.status === "COMPLETED") {
      return 100;
    }
    if (message.status === "NOT_STARTED") {
      return 0;
    }
    return parseInt(((message.finished / (message.count || 1)) * 100).toString());
  }

  closeTaskWin() {
    this.showSyncWin = false;
  }

  viewSyncLog(row: any) {
    this.viewLogType = row.index;
    this.showImportLogWin = true;
  }

  closeImportLogWin() {
    this.showImportLogWin = false;
  }

  @Watch("$store.state.isLoading")
  onLoadingChange(loading: any) {
    if (loading === true) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }
}

